export const englishUser = {
  firstName: "First Name",
  lastName: "Last Name",
  email: "Email",
  nic: "NIC Number",
  mobileNumber: "Mobile Number",
  dob: "Date of Birth",
  gender: "Gender",
  dropDownTitle: "Select",
  genderType: {
    male: "Male",
    female: "Female",
    other: "Other",
  },
  city: "City",
  district: "District",
  address: "Address",
  radioButtonSection: {
    question: "Are you already enrolled in a driving school?",
    yes: "Yes",
    no: "No",
  },
  submit: "Submit",
  skip: "Skip",
  name: "Driving School Name",
  description: "Description",
  logo: "Logo",
};

export const sinhalaUser = {
  firstName: "මුල් නම",
  lastName: "අවසන් නම",
  email: "ඊමේල්",
  nic: "ජාතික හැඳුනුම්පත් අංකය",
  mobileNumber: "දුරකථන අංකය",
  dob: "උපන් දිනය",
  gender: "ස්ත්‍රී / පුරුෂ භාවය ",
  dropDownTitle: "තෝරන්න",
  genderType: {
    male: "පුරුෂ",
    female: "ස්ත්‍රී",
    other: "වෙනත්",
  },
  city: "නගරය",
  district: "දිස්ත්‍රික්කය",
  address: "ලිපිනය",
  radioButtonSection: {
    question: "ඔබ දැනටමත් රියපුහුණු පාසලකට ඇතුලත් වී සිටින්නේද ? ",
    yes: "ඔව්",
    no: "නැත ",
  },
  submit: "තොරතුරු ඇතුලත් කරන්න",
  skip: "මඟ හරින්න",
  name: "Driving School Name",
  description: "Description",
  logo: "Logo",
};

export const tamilUser = {
  firstName: "முதல் பெயர்",
  lastName: "கடைசி பெயர்",
  email: "மின்னஞ்சல்",
  nic: "தேசிய அடையாள அட்டை எண்",
  mobileNumber: "மொபைல் எண்",
  dob: "பிறந்த தேதி",
  gender: "பாலினம்",
  dropDownTitle: "தேர்ந்தெடு",
  genderType: {
    male: "ஆண்",
    female: "பெண் ஆண்",
    other: "மற்றவை",
  },
  city: "நகரம்",
  district: "மாவட்டம்",
  address: "முகவரி",
  radioButtonSection: {
    question: "நீங்கள் ஏற்கனவே ஓட்டுநர் பள்ளியில் சேர்ந்திருக்கிறீர்களா?",
    yes: "ஆம்",
    no: "இல்லை",
  },
  submit: "சமர்ப்பிக்கவும்",
  skip: "தவிர்க்கவும்",
  name: "Driving School Name",
  description: "Description",
  logo: "Logo",
};
